import styled from 'styled-components';

import ActionButton from 'components/action-button';
import BlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';
import { slideIn } from 'utils/style/animations';

const BACKGROUND_WITH_OPACITY = `${Styles.color.background}AA`;

export const Overlay = styled.div`
  height: 100vh;
  width: 100%;
  position: absolute;
  background-color: ${BACKGROUND_WITH_OPACITY};
  z-index: ${Styles.zIndex.overlay};
`;

export const CooldownDrawerContainer = styled.div`
  bottom: 0;
  position: absolute;
  width: 100%;
  background-color: ${Styles.color.alert.info.background};
  border-radius: 0.5rem 0.5rem 0 0;
  color: ${primitive.$white};
  display: flex;
  flex-flow: column wrap;
  align-items: center;
  padding: 2rem;
  font-family: ${Styles.fontFamily.base};
  font-size: 0.875rem;
  line-height: 0.875rem;
  animation: ${slideIn} 0.4s 0.15s forwards;
  z-index: ${Styles.zIndex.overlay};
`;

export const Image = styled.img``;
export const Title = styled.p`
  font-weight: bold;
  font-size: 1.125rem;
  line-height: 1.375rem;
  margin-bottom: 0;
`;
export const Description = styled.p`
  font-size: 0.9375rem;
  line-height: 1.3125rem;
  margin-top: 1rem;
  text-align: center;
`;
export const CTAButton = styled(ActionButton)`
  font-size: 1rem;
  padding: 0.5rem 1.5rem;
`;
export const Terms = styled(BlockRenderer)``;
